import { format, parseISO } from 'date-fns'

export const PATH_INFO = {
  LOGIN: {
    PATH:"/login"
  },
  HOME: {
    PATH: "/"
  },
  PAST_MEASUREMENTS: {
    PATH: '/past-measurements'
  },
  SPECIFICATION_INPORT: {
    PATH: '/specification-inport'
  },
    SPECIFICATION_DOWNLOAD: {
    PATH: '/specification-download'
  },
  QR_SEARCH: {
    PATH: '/qr-search'
  },
  EC_PHOTO: {
    PATH: '/ec-photo'
  },
}

const ordinalRules = new Intl.PluralRules('en-US', { type: 'ordinal' })
const ordinalSuffixMap: Record<Intl.LDMLPluralRule, string> = {
  one: 'st',
  two: 'nd',
  few: 'rd',
  other: 'th',
  many: 'th',
  zero: 'th'
}

export function formatOrdinal(num: number) {
  const rule = ordinalRules.select(num)
  const suffix = ordinalSuffixMap[rule] ?? ordinalSuffixMap.other
  return `${num}${suffix}`
}

export function formatDate(date: string) {
  try {
    const parsedDate = parseISO(date)
    if (Number.isNaN(parsedDate.getTime())) {
      return ''
    }
    return format(parsedDate, 'yyyy/MM/dd')
  } catch (error) {
    console.error('formatDate failed:', error)
    return ''
  }
}

export function formatNumber(num: number) {
  const number = ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧', '⑨', '⑩', '⑪', '⑫', '⑬', '⑭', '⑮', '⑯', '⑰', '⑱', '⑲', '⑳', '㉑', '㉒', '㉓', '㉔', '㉕', '㉖', '㉗', '㉘', '㉙', '㉚']

  const result = number[num - 1]
  return result
}

export const MEASURE_COLOR_LIST = [
  { measure_index: 1, color: '#16E7E7' },
  { measure_index: 2, color: '#06B6B6' },
  { measure_index: 3, color: '#7AB3FF' },
  { measure_index: 4, color: '#007BFF' },
  { measure_index: 5, color: '#0036D9' },
  { measure_index: 6, color: '#000092' },
  { measure_index: 7, color: '#D940FF' },
  { measure_index: 8, color: '#9900CC' },
  { measure_index: 9, color: '#660066' },
  { measure_index: 10, color: '#FF66CC' },
  { measure_index: 11, color: '#F3007A' },
  { measure_index: 12, color: '#99336B' },
  { measure_index: 13, color: '#660033' },
  { measure_index: 14, color: '#FF9999' },
  { measure_index: 15, color: '#FF6C6C' },
  { measure_index: 16, color: '#FD0000' },
  { measure_index: 17, color: '#C80003' },
  { measure_index: 18, color: '#CC6600' },
  { measure_index: 19, color: '#FF9900' },
  { measure_index: 20, color: '#FFC800' },
  { measure_index: 21, color: '#ABAE0A' },
  { measure_index: 22, color: '#FFF200' },
  { measure_index: 23, color: '#CCFF33' },
  { measure_index: 24, color: '#00FF00' },
  { measure_index: 25, color: '#00C800' },
  { measure_index: 26, color: '#007D00' },
  { measure_index: 27, color: '#C5A3FF' },
  { measure_index: 28, color: '#936FD0' },
  { measure_index: 29, color: '#513089' },
  { measure_index: 30, color: '#2D0061' },
]

export const SIZE_LIST = {
  LadiesAndMans: { label: 'レディース/メンズ', size: [ 'XS', 'S', 'M', 'L', 'XL' ]},
  Kids: { label: 'KIDS', size: [ '80cm', '90cm', '100cm', '110cm', '120cm' ]},
  MailOrderBrand: { label: '通販ブランド', size: [ '2L', '3L' ]}
}
